export const baseUrl = 'https://api.itunisoft.uz'
